import React from "react";
import "./terms.layout.sass";
import { Icon } from "rsuite";
import Axios from "axios";
import { Setting } from "../../setting";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";

class TermsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
    };
  }

  componentDidMount() {
    Axios.get(`${Setting.apiUrl}api/termCondition/list`).then((res) => {
      this.setState({
        data: res.data.data,
      });
    });
  }

  render() {
    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
      position: relative;
    `;

    return (
      <div className="terms-layout">
        <div className="terms-container-div">
          <h2>
            <Icon icon="circle" /> قوانین و مقررات
          </h2>
          <br />
          {this.state.data ? (
            this.state.data.map((item, i) => (
              <div key={i}>
                <h5>
                  <Icon icon="arrow-left" />
                  {item.title}
                </h5>
                <p>{item.descrption}</p> <br />
              </div>
            ))
          ) : (
            <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
          )}
        </div>
      </div>
    );
  }
}

export default TermsLayout;
